import React, { useState, useEffect, useReducer, useCallback, useContext, useMemo } from 'react';
// import styles from './FieldsManagment.module.css';

import CrmGrid from '../../../UI/Crm/CrmGrid/CrmGrid';
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from "react-i18next";
import SubModal from '../../../UI/Crm/SubModal/SubModal';
import CrmTextField from '../../../UI/Crm/Fields/CrmTextField'
import CrmSelectField from '../../../UI/Crm/Fields/CrmSelectField';
import CrmCheckBoxField from '../../../UI/Crm/Fields/CrmCheckBoxField';
import CrmButton from '../../../UI/Crm/CrmButton/CrmButton';
import CrmDivider from '../../../UI/Crm/CrmLayout/CrmDivider';
import CrmDateTime from '../../../UI/Crm/Fields/CrmDateTime';
import AlertContext from '../../../../context/AlertModelContext/AlertModalContext'
import * as actions from '../../../../store/actions/index'
import { Box } from '@mui/material';
import validator from 'validator';
import { getDropDownList, updateDropDownList, updateDropDownItem, deleteDropDownItem, deleteDropDown, insertDropDownList } from '../../../../axios/requests/dropDownReq'

const initDropDownState = {
    dropDownsArr: [],
    selectedDropDownObj: {},
    selectedDropDownOption: {},
    selectedChildOption: { label: 'Create new child option', value: 'Create', key: 'Create' }, // Currently selected child option for editing
    selectedGrandChildOption: { label: 'Create new child option', value: 'Create', key: 'Create' }, // Currently selected grandchild option for editing
    childDropDowns: [], // For nested children management
    selectedChildOptions: {} // Track selected values for each level
}

//         const newObj = JSON.parse(JSON.stringify(prevState))
//         newObj.name = newValue
//         return newObj

const dropDownReducer = (state, action) => {
    switch (action.type) {
        case 'init':
            const { dropDownsArr } = action.payload
            return { ...state, dropDownsArr, selectedDropDownObj: action.payload.selectedDropDownObj, selectedDropDownOption: action.payload.selectedDropDownOption, childDropDowns: [], selectedChildOptions: {} }
        case 'SET_DROPDOWN_OBJ':
            const selectedDropDownObj = state.dropDownsArr.find((dropDown) => dropDown.value === action.payload.value)
            if (!selectedDropDownObj || !selectedDropDownObj.dropDownItems || selectedDropDownObj.dropDownItems.length === 0) {
                return state
            }
            return { ...state, selectedDropDownObj, selectedDropDownOption: selectedDropDownObj.dropDownItems[0], childDropDowns: [], selectedChildOptions: {} }
        case 'SET_DROPDOWN_SELECTED_OPTION':
            if (!state.selectedDropDownObj || !state.selectedDropDownObj.dropDownItems) {
                return state
            }
            const selectedDropDownOption = state.selectedDropDownObj.dropDownItems.find((dropDownOption) => dropDownOption.value === action.payload.value)
            if (!selectedDropDownOption) {
                return state
            }
            // Build child dropdown hierarchy when parent changes
            const childDropDowns = selectedDropDownOption?.children ? [selectedDropDownOption.children] : []
            const selectedChildOptions = {}
            // Auto-select if child has only one option
            if (childDropDowns.length > 0 && childDropDowns[0].length === 1 && childDropDowns[0][0].autoSelect) {
                selectedChildOptions[0] = childDropDowns[0][0].value
            }
            return { ...state, selectedDropDownOption, childDropDowns, selectedChildOptions }
        case 'UPDATE_CHILD_DROPDOWNS':
            // Update the child dropdown levels when the selected option changes
            const currentOption = state.selectedDropDownOption
            const updatedChildDropDowns = currentOption?.children ? [currentOption.children] : []
            const updatedSelectedChildOptions = {}

            return { ...state, childDropDowns: updatedChildDropDowns, selectedChildOptions: updatedSelectedChildOptions }
        case 'CHANGE_DROPDOWN_NAME':
            const newSelectedDropDownObj = JSON.parse(JSON.stringify(state.selectedDropDownObj))
            newSelectedDropDownObj.name = newSelectedDropDownObj.label = newSelectedDropDownObj.value = action.payload.value
            return { ...state, selectedDropDownObj: newSelectedDropDownObj }
        case 'CHANGE_DROPDOWN_SELECTED_OPTION_NAME':
            const newSelectedDropDownOption = JSON.parse(JSON.stringify(state.selectedDropDownOption))
            newSelectedDropDownOption.name = newSelectedDropDownOption.label = newSelectedDropDownOption.key = newSelectedDropDownOption.value = action.payload.value
            return { ...state, selectedDropDownOption: newSelectedDropDownOption }
        case 'SAVE_DROPDOWN':
            const { savedDropDown, newCreate: createNewDropDown } = action.payload
            const dropDownsArrCopy = JSON.parse(JSON.stringify(state.dropDownsArr))
            if (!state.selectedDropDownObj?._id) {
                if (state.selectedDropDownObj?.value === 'Create') return { ...state }
                dropDownsArrCopy.push(savedDropDown)
                return { ...state, dropDownsArr: dropDownsArrCopy, selectedDropDownObj: createNewDropDown }
            }
            else {
                const dropdownIndex = dropDownsArrCopy.findIndex((dropdown) => {
                    return dropdown._id === state.selectedDropDownObj._id
                })
                dropDownsArrCopy.splice(dropdownIndex, 1, state.selectedDropDownObj)
                return { ...state, dropDownsArr: dropDownsArrCopy }
            }

        case 'SAVE_DROPDOWN_OPTION':
            const { updatedDropDownOption, newCreate: createNewOption } = action.payload
            const dropDownsArrCopy2 = JSON.parse(JSON.stringify(state.dropDownsArr))
            const selectedDropDownObj2 = JSON.parse(JSON.stringify(state.selectedDropDownObj))
            const dropDownObj = dropDownsArrCopy2.find(dropdown => dropdown._id === state.selectedDropDownObj._id)
            const dropDownOptionIndex = dropDownObj.dropDownItems.findIndex((dropDownItem) => dropDownItem._id === updatedDropDownOption._id)
            if (dropDownOptionIndex > -1) {
                dropDownObj.dropDownItems.splice(dropDownOptionIndex, 1, updatedDropDownOption)
                selectedDropDownObj2.dropDownItems.splice(dropDownOptionIndex, 1, updatedDropDownOption)
                return { ...state, dropDownsArr: dropDownsArrCopy2, selectedDropDownObj: selectedDropDownObj2, selectedDropDownOption: updatedDropDownOption }
            }
            else {
                dropDownObj.dropDownItems.push(updatedDropDownOption)
                selectedDropDownObj2.dropDownItems.push(updatedDropDownOption)

                return { ...state, dropDownsArr: dropDownsArrCopy2, selectedDropDownObj: selectedDropDownObj2, selectedDropDownOption: createNewOption }
            }
        case 'REMOVE_DROPDOWN_OPTION':
            const { newCreate: createNew } = action.payload
            const dropDownsArrCopy3 = JSON.parse(JSON.stringify(state.dropDownsArr))
            const selectedDropDownObj3 = JSON.parse(JSON.stringify(state.selectedDropDownObj))
            const dropDownObj3 = dropDownsArrCopy3.find(dropdown => dropdown._id === state.selectedDropDownObj._id)
            const dropDownOptionIndex3 = dropDownObj3.dropDownItems.findIndex((dropDownItem) => dropDownItem._id === state.selectedDropDownOption._id)
            if (dropDownOptionIndex3 > -1) {
                dropDownObj3.dropDownItems.splice(dropDownOptionIndex3, 1)
                selectedDropDownObj3.dropDownItems.splice(dropDownOptionIndex3, 1)
                return { ...state, dropDownsArr: dropDownsArrCopy3, selectedDropDownObj: selectedDropDownObj3, selectedDropDownOption: createNew }
            }
            return state
        case 'TOGGLE_CHILD_DROPDOWN':
            const { hasChildren } = action.payload
            const updatedSelectedOption = JSON.parse(JSON.stringify(state.selectedDropDownOption))

            if (hasChildren) {
                // Add children array if it doesn't exist
                if (!updatedSelectedOption.children) {
                    updatedSelectedOption.children = []
                }
            } else {
                // Remove children array
                delete updatedSelectedOption.children
            }

            // Update child dropdowns when toggling
            const newChildDropDownsOnToggle = updatedSelectedOption?.children ? [updatedSelectedOption.children] : []
            const resetChildOption = { label: 'Create new child option', value: 'Create', key: 'Create' }

            return { ...state, selectedDropDownOption: updatedSelectedOption, childDropDowns: newChildDropDownsOnToggle, selectedChildOptions: {}, selectedChildOption: resetChildOption }
        case 'UPDATE_CHILD_PROPERTY':
            const { property, propertyValue } = action.payload
            const updatedOption = JSON.parse(JSON.stringify(state.selectedDropDownOption))

            if (updatedOption) {
                updatedOption[property] = propertyValue
            }

            return { ...state, selectedDropDownOption: updatedOption }
        case 'SET_SELECTED_CHILD_OPTION':
            const selectedChildOption = state.selectedDropDownOption?.children?.find(child => child.value === action.payload.value) || { label: 'Create new child option', value: 'Create', key: 'Create' }
            return { ...state, selectedChildOption }
        case 'CHANGE_CHILD_OPTION_NAME':
            const newSelectedChildOption = JSON.parse(JSON.stringify(state.selectedChildOption))
            newSelectedChildOption.key = newSelectedChildOption.value = action.payload.value
            return { ...state, selectedChildOption: newSelectedChildOption }
        case 'SET_SELECTED_GRANDCHILD_OPTION':
            const selectedGrandChildOption = state.selectedChildOption?.children?.find(grandchild => grandchild.value === action.payload.value) || { label: 'Create new child option', value: 'Create', key: 'Create' }
            return { ...state, selectedGrandChildOption }
        case 'CHANGE_GRANDCHILD_OPTION_NAME':
            const newSelectedGrandChildOption = JSON.parse(JSON.stringify(state.selectedGrandChildOption))
            newSelectedGrandChildOption.key = newSelectedGrandChildOption.value = action.payload.value
            return { ...state, selectedGrandChildOption: newSelectedGrandChildOption }
        case 'ADD_CHILD_OPTION':
            const { childOption } = action.payload
            const optionWithChild = JSON.parse(JSON.stringify(state.selectedDropDownOption))

            if (optionWithChild && Array.isArray(optionWithChild.children)) {
                optionWithChild.children.push(childOption)
            }

            // Update child dropdowns to reflect the new option
            const addChildDropDowns = optionWithChild?.children ? [optionWithChild.children] : []

            return { ...state, selectedDropDownOption: optionWithChild, childDropDowns: addChildDropDowns }
        case 'REMOVE_CHILD_OPTION':
            const { childIndex } = action.payload
            const optionWithoutChild = JSON.parse(JSON.stringify(state.selectedDropDownOption))

            if (optionWithoutChild && Array.isArray(optionWithoutChild.children)) {
                optionWithoutChild.children.splice(childIndex, 1)
            }

            // Update child dropdowns to reflect the removal
            const updatedChildDropDownsAfterRemove = optionWithoutChild?.children ? [optionWithoutChild.children] : []

            return { ...state, selectedDropDownOption: optionWithoutChild, childDropDowns: updatedChildDropDownsAfterRemove }
        case 'UPDATE_CHILD_OPTION':
            const { childIndex: updateIndex, updatedChildOption } = action.payload
            const optionWithUpdatedChild = JSON.parse(JSON.stringify(state.selectedDropDownOption))

            if (optionWithUpdatedChild && Array.isArray(optionWithUpdatedChild.children)) {
                optionWithUpdatedChild.children[updateIndex] = updatedChildOption
            }

            // Update child dropdowns to reflect the update
            const updatedChildDropDownsAfterUpdate = optionWithUpdatedChild?.children ? [optionWithUpdatedChild.children] : []

            return { ...state, selectedDropDownOption: optionWithUpdatedChild, childDropDowns: updatedChildDropDownsAfterUpdate }
        case 'SET_CHILD_LEVEL_NAME':
            const updatedOptionWithName = JSON.parse(JSON.stringify(state.selectedDropDownOption))
            updatedOptionWithName.childLevelName = action.payload.value
            return { ...state, selectedDropDownOption: updatedOptionWithName }
        case 'CLEAR_ALL':
            return initDropDownState
        default:
            return state
    }
}

const newFieldObj = {
    type: 'text',
    name: '',
    label: '',
    tooltip: '',
    defaultValue: undefined,
    maxNumber: '',
    required: false,
    showColumns: false,
    showFilters: false,
    importable: false,
    displayField: ''
}

const initManageFieldState = {
    fieldObj: null,
    showModal: false,
    mode: null// [INSERT,PATCH]
}

// Recursive component for unlimited depth child management
const RecursiveChildManager = ({ parentOption, dropDownState, dropDownDispatch, updateDropDownItem, alertCtx, t, level, path = [] }) => {
    const [newOptionName, setNewOptionName] = useState('');
    const [selectedOption, setSelectedOption] = useState({ label: 'Create new child option', value: 'Create', key: 'Create' });

    const currentPath = [...path, level];

    // Get the current parent from the global state to ensure we have the latest data
    const getCurrentParent = useCallback(() => {
        if (level === 0) {
            return dropDownState.selectedDropDownOption;
        }

        let current = dropDownState.selectedDropDownOption;

        // Navigate through the path to find the correct location
        for (let i = 0; i < path.length; i++) {
            const pathIndex = path[i];
            if (current.children && current.children[pathIndex]) {
                current = current.children[pathIndex];
            } else {
                // If path navigation fails, fallback to searching by value
                console.warn('Path navigation failed at index', i, 'pathIndex', pathIndex);
                break;
            }
        }

        // For deeper levels, we need to find the parent by walking through the entire tree
        // using the parentOption value as a reference
        const findParentByValue = (node, targetValue) => {
            if (!node || !Array.isArray(node.children)) return null;

            // Check direct children
            for (const child of node.children) {
                if (child.value === targetValue) {
                    return child;
                }
                // Recursively search in nested children
                const found = findParentByValue(child, targetValue);
                if (found) return found;
            }
            return null;
        };

        const foundParent = findParentByValue(dropDownState.selectedDropDownOption, parentOption.value);
        return foundParent || parentOption;
    }, [level, path, dropDownState.selectedDropDownOption, parentOption]);

    const currentParent = getCurrentParent();

    // Reset to "Create" when parent changes or children are added
    useEffect(() => {
        setSelectedOption({ label: 'Create new child option', value: 'Create', key: 'Create' });
    }, [currentParent?.children?.length]);

    const handleSaveOption = useCallback(async () => {
        try {
            let updatedRootOption = JSON.parse(JSON.stringify(dropDownState.selectedDropDownOption));

            if (selectedOption.value === 'Create') {
                // Add new child option
                if (newOptionName.trim()) {
                    const newChildOption = {
                        key: newOptionName.trim(),
                        value: newOptionName.trim().toLowerCase().replace(/\s+/g, '_'),
                    };

                    // Find the correct parent in the updated root option tree
                    let targetParent = updatedRootOption;
                    if (level > 0) {
                        // Navigate through the path to find the correct parent
                        for (let i = 0; i < path.length; i++) {
                            const pathIndex = path[i];
                            if (targetParent.children && targetParent.children[pathIndex]) {
                                targetParent = targetParent.children[pathIndex];
                            }
                        }
                        // Now find the current parent option in this level
                        const parentIndex = targetParent.children?.findIndex(child => child.value === parentOption.value);
                        if (parentIndex !== -1 && targetParent.children) {
                            targetParent = targetParent.children[parentIndex];
                        }
                    }

                    if (!Array.isArray(targetParent.children)) {
                        targetParent.children = [];
                    }
                    targetParent.children.push(newChildOption);

                    setNewOptionName('');
                    setSelectedOption({ label: 'Create new child option', value: 'Create', key: 'Create' });
                }
            } else {
                // Update existing child option
                let targetParent = updatedRootOption;
                if (level > 0) {
                    // Navigate through the path to find the correct parent
                    for (let i = 0; i < path.length; i++) {
                        const pathIndex = path[i];
                        if (targetParent.children && targetParent.children[pathIndex]) {
                            targetParent = targetParent.children[pathIndex];
                        }
                    }
                    // Now find the current parent option in this level
                    const parentIndex = targetParent.children?.findIndex(child => child.value === parentOption.value);
                    if (parentIndex !== -1 && targetParent.children) {
                        targetParent = targetParent.children[parentIndex];
                    }
                }

                const childIndex = targetParent.children?.findIndex(child => child.value === selectedOption.value);
                if (childIndex !== -1 && targetParent.children) {
                    targetParent.children[childIndex] = { ...selectedOption };
                }
            }

            // Update global state
            dropDownDispatch({
                type: 'SAVE_DROPDOWN_OPTION',
                payload: {
                    updatedDropDownOption: updatedRootOption,
                    newCreate: { label: t('Create new drop down option'), value: 'Create', key: 'Create' }
                }
            });

            // Show loading spinner in alert modal
            alertCtx.showAlert('', <div style={{ textAlign: 'center', padding: '20px' }}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

            // Save to backend
            await updateDropDownItem(dropDownState.selectedDropDownObj, updatedRootOption);

            // Hide the loading spinner on success
            alertCtx.hideAlert()
        } catch (error) {
            console.error('Failed to save option:', error);
            alertCtx.showAlert(t('Error'), t('Failed to save changes'), 'sm');
        }
    }, [selectedOption, newOptionName, dropDownState, level, parentOption, path, t, alertCtx, updateDropDownItem, dropDownDispatch]);

    const handleDeleteOption = useCallback(async () => {
        if (selectedOption.value === 'Create') return;

        try {
            let updatedRootOption = JSON.parse(JSON.stringify(dropDownState.selectedDropDownOption));

            // Find the correct parent in the updated root option tree
            let targetParent = updatedRootOption;
            if (level > 0) {
                // Navigate through the path to find the correct parent
                for (let i = 0; i < path.length; i++) {
                    const pathIndex = path[i];
                    if (targetParent.children && targetParent.children[pathIndex]) {
                        targetParent = targetParent.children[pathIndex];
                    }
                }
                // Now find the current parent option in this level
                const parentIndex = targetParent.children?.findIndex(child => child.value === parentOption.value);
                if (parentIndex !== -1 && targetParent.children) {
                    targetParent = targetParent.children[parentIndex];
                }
            }

            const childIndex = targetParent.children?.findIndex(child => child.value === selectedOption.value);
            if (childIndex !== -1 && targetParent.children) {
                targetParent.children.splice(childIndex, 1);
            }

            // Reset to Create option
            setSelectedOption({ label: 'Create new child option', value: 'Create', key: 'Create' });

            // Update global state
            dropDownDispatch({
                type: 'SAVE_DROPDOWN_OPTION',
                payload: {
                    updatedDropDownOption: updatedRootOption,
                    newCreate: { label: t('Create new drop down option'), value: 'Create', key: 'Create' }
                }
            });

            // Show loading spinner in alert modal
            alertCtx.showAlert('', <div style={{ textAlign: 'center', padding: '20px' }}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

            // Save to backend
            await updateDropDownItem(dropDownState.selectedDropDownObj, updatedRootOption);

            // Hide the loading spinner on success
            alertCtx.hideAlert()
        } catch (error) {
            console.error('Failed to delete option:', error);
            alertCtx.showAlert(t('Error'), t('Failed to save changes'), 'sm');
        }
    }, [selectedOption, dropDownState, level, parentOption, path, t, alertCtx, updateDropDownItem, dropDownDispatch]);

    const handleToggleChildren = useCallback(async (hasChildren) => {
        try {
            let updatedRootOption = JSON.parse(JSON.stringify(dropDownState.selectedDropDownOption));

            // Find the correct parent in the updated root option tree
            let targetParent = updatedRootOption;
            if (level > 0) {
                // Navigate through the path to find the correct parent
                for (let i = 0; i < path.length; i++) {
                    const pathIndex = path[i];
                    if (targetParent.children && targetParent.children[pathIndex]) {
                        targetParent = targetParent.children[pathIndex];
                    }
                }
                // Now find the current parent option in this level
                const parentIndex = targetParent.children?.findIndex(child => child.value === parentOption.value);
                if (parentIndex !== -1 && targetParent.children) {
                    targetParent = targetParent.children[parentIndex];
                }
            }

            const childIndex = targetParent.children?.findIndex(child => child.value === selectedOption.value);
            if (childIndex !== -1 && targetParent.children) {
                const updatedOption = { ...targetParent.children[childIndex] };
                if (hasChildren) {
                    if (!updatedOption.children) {
                        updatedOption.children = [];
                    }
                } else {
                    delete updatedOption.children;
                }
                targetParent.children[childIndex] = updatedOption;
                setSelectedOption(updatedOption);
            }

            // Update global state
            dropDownDispatch({
                type: 'SAVE_DROPDOWN_OPTION',
                payload: {
                    updatedDropDownOption: updatedRootOption,
                    newCreate: { label: t('Create new drop down option'), value: 'Create', key: 'Create' }
                }
            });

            // Show loading spinner in alert modal
            alertCtx.showAlert('', <div style={{ textAlign: 'center', padding: '20px' }}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

            // Save to backend
            await updateDropDownItem(dropDownState.selectedDropDownObj, updatedRootOption);

            // Hide the loading spinner on success
            alertCtx.hideAlert()
        } catch (error) {
            console.error('Failed to update option:', error);
            alertCtx.showAlert(t('Error'), t('Failed to save changes'), 'sm');
        }
    }, [selectedOption, newOptionName, dropDownState, level, parentOption, path, t, alertCtx, updateDropDownItem, dropDownDispatch]);

    if (!Array.isArray(currentParent?.children)) {
        return null;
    }

    return (
        <Box mt={level > 0 ? 2 : 0}>
            <Box display="flex" gap={1} alignItems="center" width="100%">
                <CrmSelectField
                    name={`childDropdownOption-${level}`}
                    value={selectedOption?.value || ''}
                    onChange={(e) => {
                        const selected = currentParent.children.find(child => child.value === e.target.value) ||
                            { label: 'Create new child option', value: 'Create', key: 'Create' };
                        setSelectedOption(selected);
                    }}
                    label={t('Child dropdown option')}
                    options={[
                        { label: t('Create new child option'), value: 'Create', key: 'Create' },
                        ...currentParent.children.map(child => ({ ...child, label: child.key }))
                    ]}
                />
                <CrmTextField
                    label={t('Child option name')}
                    name={`childOptionName-${level}`}
                    value={selectedOption?.value === 'Create' ? newOptionName : (selectedOption?.key || '')}
                    onChange={(e) => {
                        if (selectedOption?.value === 'Create') {
                            setNewOptionName(e.target.value);
                        } else {
                            setSelectedOption(prev => ({ ...prev, key: e.target.value, value: e.target.value }));
                        }
                    }}
                    autoComplete='off'
                />
                <CrmButton variant="contained" color="crmGray" onClick={handleSaveOption}>
                    {t('Save')}
                </CrmButton>
                <CrmButton
                    variant="outlined"
                    color="crmOutLinedGray"
                    onClick={handleDeleteOption}
                    st={{ visibility: selectedOption?.value !== 'Create' ? 'visible' : 'hidden' }}
                >
                    {t('Remove')}
                </CrmButton>
                <CrmCheckBoxField
                    label={t('Add Child Dropdown')}
                    name={`hasChildren-${level}`}
                    value={Array.isArray(selectedOption?.children)}
                    onChange={async (e) => {
                        await handleToggleChildren(e.target.checked);
                    }}
                    style={{ visibility: selectedOption?.value !== 'Create' ? 'visible' : 'hidden' }}
                />
            </Box>

            {/* Custom Child Level Name Management */}
            {Array.isArray(selectedOption?.children) && selectedOption?.value !== 'Create' && (
                <Box mt={2} p={2} border="1px solid #e0e0e0" borderRadius={1} bgcolor="#f9f9f9">
                    <Box display="flex" gap={1} alignItems="center" width="100%">
                        <CrmTextField
                            label={`${t('Child Level Name')} - ${t('Level')} ${level + 2}`}
                            name={`childLevelName-${level}`}
                            value={selectedOption.childLevelName || ''}
                            onChange={(e) => {
                                setSelectedOption(prev => ({ ...prev, childLevelName: e.target.value }));
                            }}
                            placeholder={t('e.g., Category, Type, Size')}
                            autoComplete='off'
                            sx={{ flexGrow: 1 }}
                        />
                        <CrmButton
                            variant="contained"
                            color="crmGray"
                            onClick={async () => {
                                try {
                                    await handleSaveOption();
                                    alertCtx.showAlert(t('success'), t('Child level name updated successfully'), 'sm');
                                } catch (error) {
                                    console.error('Error updating child level name:', error);
                                    alertCtx.showAlert(t('error'), t('Failed to update child level name'), 'sm');
                                }
                            }}
                        >
                            {t('Save')}
                        </CrmButton>
                    </Box>
                </Box>
            )}

            {/* Recursive render of child levels */}
            {Array.isArray(selectedOption?.children) && (
                <RecursiveChildManager
                    key={`${level + 1}-${selectedOption.value}-${selectedOption?.children?.length || 0}`}
                    parentOption={selectedOption}
                    dropDownState={dropDownState}
                    dropDownDispatch={dropDownDispatch}
                    updateDropDownItem={updateDropDownItem}
                    alertCtx={alertCtx}
                    t={t}
                    level={level + 1}
                    path={[...path, currentParent?.children?.findIndex(child => child.value === selectedOption.value) || 0]}
                />
            )}
        </Box>
    );
};

const manageFieldReducer = (state, action) => {
    switch (action.type) {
        case 'TOGGEL_MODAL':
            return { ...state, showModal: !state.showModal }
        case 'SET_FIELD':
            const copyFieldObj = JSON.parse(JSON.stringify(action.fieldObj))
            // Ensure all properties exist by merging with newFieldObj defaults
            const mergedFieldObj = { ...newFieldObj, ...copyFieldObj }
            return { ...state, fieldObj: mergedFieldObj, mode: action.mode, showModal: true }
        case 'PATCH_FIELD':
            const { name, value, type, checked } = action.payload;
            const newField = { ...state.fieldObj, [name]: type === 'checkbox' ? checked : value }
            return { ...state, fieldObj: newField }
        case 'CLEAR_ALL':
            return initManageFieldState
        default:
            return state
    }
}


const FieldsManagment = () => {
    const [fields, setFields] = useState([])
    const crmState = useSelector(state => state.crm)
    const [relatedModules, setRelatedModules] = useState([])
    const [selectedModuleFields, setSelectedModuleFields] = useState([])
    const [manageFieldState, manageFieldDispatch] = useReducer(manageFieldReducer, initManageFieldState)
    const [dropDownState, dropDownDispatch] = useReducer(dropDownReducer, initDropDownState)
    const [errors, setErrors] = useState({});
    const alertCtx = useContext(AlertContext)
    const [t] = useTranslation('crm')
    const dispatch = useDispatch()

    const { selectedCrmModule } = crmState

    const fetchDropDowns = useCallback(async (fieldObj) => {
        let DropDownListTemp = await getDropDownList('CRM_DROPDOWN');
        DropDownListTemp.unshift({ label: t('Create new drop down'), value: 'Create', category: "CRM_DROPDOWN", dropDownItems: [] })
        DropDownListTemp.forEach((dropDown) => {
            dropDown.label = dropDown.label || dropDown.name
            // Add lock/edit emoji to dropdown label
            if (dropDown.isEditable === false) {
                dropDown.label = `🔒 ${dropDown.label}`
            } else {
                dropDown.label = `✏️ ${dropDown.label}`
            }
            dropDown.value = dropDown.value || dropDown._id
            dropDown.dropDownItems.forEach((dropDownOption) => {
                dropDownOption.label = dropDownOption.key
                // Add lock/edit emoji to option label
                if (dropDown.isEditable === false) {
                    dropDownOption.label = `🔒 ${dropDownOption.label}`
                } else {
                    dropDownOption.label = `✏️ ${dropDownOption.label}`
                }
            })
            dropDown.dropDownItems.unshift({ label: t('Create new drop down option'), value: 'Create', key: 'Create' })
        }
        )

        if (fieldObj?.dropDownId?.dropDownItems) {
            const selectedDropDownItem = JSON.parse(JSON.stringify(fieldObj.dropDownId))
            selectedDropDownItem.label = selectedDropDownItem.label || selectedDropDownItem.name
            // Add lock/edit emoji to dropdown label
            if (selectedDropDownItem.isEditable === false) {
                selectedDropDownItem.label = `🔒 ${selectedDropDownItem.label}`
            } else {
                selectedDropDownItem.label = `✏️ ${selectedDropDownItem.label}`
            }
            selectedDropDownItem.value = selectedDropDownItem.value || selectedDropDownItem._id
            selectedDropDownItem.dropDownItems.forEach((dropDownOption) => {
                dropDownOption.label = dropDownOption.key
                // Add lock/edit emoji to option label
                if (selectedDropDownItem.isEditable === false) {
                    dropDownOption.label = `🔒 ${dropDownOption.label}`
                } else {
                    dropDownOption.label = `✏️ ${dropDownOption.label}`
                }
            })
            selectedDropDownItem.dropDownItems.unshift({ label: t('Create new drop down option'), value: 'Create', key: 'Create' })
            dropDownDispatch({
                type: 'init',
                payload: {
                    dropDownsArr: DropDownListTemp,
                    selectedDropDownObj: selectedDropDownItem,
                    selectedDropDownOption: selectedDropDownItem.dropDownItems.find((dropDownItem) => dropDownItem.value === fieldObj.defaultValue) || { label: t('Create new drop down option'), value: 'Create', key: 'Create' }
                }
            })
        }
        else {
            dropDownDispatch({
                type: 'init',
                payload: {
                    dropDownsArr: DropDownListTemp,
                    selectedDropDownObj: DropDownListTemp[0],
                    selectedDropDownOption: DropDownListTemp[0].dropDownItems[0]
                }
            })
        }
    }, [])


    //Init dropdown object
    useEffect(() => {
        fetchDropDowns(manageFieldState.fieldObj)
    }, [!!manageFieldState.fieldObj])

    const onSaveDropDownClickedHandler = useCallback(async () => {
        try {
            // Show loading spinner
            alertCtx.showAlert('', <div style={{textAlign: 'center', padding: '20px'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

            let savedDropDown
            if (!dropDownState.selectedDropDownObj?._id) {
                if (dropDownState.selectedDropDownObj?.value === 'Create') {
                    alertCtx.hideAlert()
                    return
                }
                savedDropDown = await insertDropDownList(dropDownState.selectedDropDownObj)
                savedDropDown.label = savedDropDown.label || savedDropDown.name
                savedDropDown.value = savedDropDown.value || savedDropDown._id
                savedDropDown.dropDownItems.forEach((dropDownOption) => {
                    dropDownOption.label = dropDownOption.key
                })
                savedDropDown.dropDownItems.unshift({ label: t('Create new drop down option'), value: 'Create', key: 'Create' })
            }
            else {
                savedDropDown = await updateDropDownList(dropDownState.selectedDropDownObj._id, dropDownState.selectedDropDownObj)
            }

            const newCreate = { label: t('Create new drop down'), value: 'Create', category: "CRM_DROPDOWN", dropDownItems: [] }
            dropDownDispatch({ type: 'SAVE_DROPDOWN', payload: { savedDropDown, newCreate } })

            alertCtx.showAlert(t('success'), t('Dropdown saved successfully'), 'sm')
        } catch (error) {
            console.error('Failed to save dropdown:', error)
            const backendMsg = error.response?.data?.message
            // Translate known backend error messages
            const errorMsg = backendMsg ? t(backendMsg) : t('Failed to save dropdown. This dropdown may not be editable.')
            alertCtx.showAlert(t('fail'), errorMsg, 'sm')
        }
    }, [dropDownState.selectedDropDownObj, alertCtx, t])

    const onSaveDropDownOptionClickedHandler = useCallback(async () => {
        try {
            // Show loading spinner
            alertCtx.showAlert('', <div style={{textAlign: 'center', padding: '20px'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

            const updatedDropDown = await updateDropDownItem(dropDownState.selectedDropDownObj, dropDownState.selectedDropDownOption)
            let updatedDropDownOption
            if (dropDownState.selectedDropDownOption?._id) {
                updatedDropDownOption = updatedDropDown.dropDownItems.find((dropDown) => dropDown._id === dropDownState.selectedDropDownOption._id)
            }
            else {
                updatedDropDownOption = updatedDropDown.dropDownItems[updatedDropDown.dropDownItems.length - 1]
            }
            updatedDropDownOption.label = updatedDropDownOption.key
            const newCreate = { label: t('Create new drop down option'), value: 'Create', key: 'Create' }
            dropDownDispatch({ type: 'SAVE_DROPDOWN_OPTION', payload: { updatedDropDownOption, newCreate } })

            alertCtx.showAlert(t('success'), t('Dropdown option saved successfully'), 'sm')
        } catch (error) {
            console.error('Failed to save dropdown option:', error)
            const backendMsg = error.response?.data?.message
            // Translate known backend error messages
            const errorMsg = backendMsg ? t(backendMsg) : t('Failed to save dropdown option.')
            alertCtx.showAlert(t('fail'), errorMsg, 'sm')
        }
    }, [dropDownState.selectedDropDownObj, dropDownState.selectedDropDownOption, alertCtx, t])

    const onDeleteDropDownClickHandler = useCallback(async () => {
        try {
            if (!dropDownState.selectedDropDownObj?._id) return

            // Show loading spinner
            alertCtx.showAlert('', <div style={{textAlign: 'center', padding: '20px'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

            await deleteDropDown(dropDownState.selectedDropDownObj._id)
            fetchDropDowns()

            alertCtx.showAlert(t('success'), t('Dropdown deleted successfully'), 'sm')
        } catch (error) {
            console.error('Failed to delete dropdown:', error)
            const backendMsg = error.response?.data?.message
            // Translate known backend error messages
            const errorMsg = backendMsg ? t(backendMsg) : t('Failed to delete dropdown.')
            alertCtx.showAlert(t('fail'), errorMsg, 'sm')
        }
    }, [dropDownState.selectedDropDownObj, alertCtx, t, fetchDropDowns])

    const onDeleteDropDownOptionClickHandler = useCallback(async () => {
        try {
            // Show loading spinner
            alertCtx.showAlert('', <div style={{textAlign: 'center', padding: '20px'}}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

            await deleteDropDownItem(dropDownState.selectedDropDownObj, dropDownState.selectedDropDownOption)
            const newCreate = { label: t('Create new drop down option'), value: 'Create', key: 'Create' }
            dropDownDispatch({ type: 'REMOVE_DROPDOWN_OPTION', payload: { newCreate } })

            alertCtx.showAlert(t('success'), t('Dropdown option deleted successfully'), 'sm')
        } catch (error) {
            console.error('Failed to delete dropdown option:', error)
            const backendMsg = error.response?.data?.message
            // Translate known backend error messages
            const errorMsg = backendMsg ? t(backendMsg) : t('Failed to delete dropdown option.')
            alertCtx.showAlert(t('fail'), errorMsg, 'sm')
        }
    }, [dropDownState.selectedDropDownObj, dropDownState.selectedDropDownOption, alertCtx, t])

    // Helper function to save dropdown item with current state
    const saveDropDownItem = useCallback(async (updatedOption = null) => {
        try {
            const optionToSave = updatedOption || dropDownState.selectedDropDownOption;
            await updateDropDownItem(dropDownState.selectedDropDownObj, optionToSave);
        } catch (error) {
            console.error('Failed to save dropdown item:', error);
            alertCtx.showAlert(t('Error'), t('Failed to save changes'), 'sm');
            throw error;
        }
    }, [dropDownState.selectedDropDownObj, dropDownState.selectedDropDownOption, t, alertCtx])


    useEffect(() => {
        let fields = []
        if (selectedCrmModule?.sections?.length) {
            for (const section of selectedCrmModule.sections) {
                fields = [...fields, ...section.fields]
            }
            setFields(fields)
        }
        if (selectedCrmModule?.relatedModules?.length) {
            const relatedModulesCopy = JSON.parse(JSON.stringify(selectedCrmModule.relatedModules)).filter((relatedModule) =>
            (
                (
                    relatedModule.relationShipType === 'ONE_TO_ONE' ||
                    (relatedModule.relationShipType === 'ONE_TO_MANY' && relatedModule.isPrimary)
                )
                &&
                !fields.find((field) => {
                    return field.name === `crmName${relatedModule.name}`
                }
                )
            ))
            relatedModulesCopy.forEach((relatedModule) => {
                relatedModule.value = relatedModule.moduleId?._id
            })
            // debugger
            relatedModulesCopy.unshift({ label: t('Empty'), value: undefined })
            setRelatedModules(relatedModulesCopy)
        }

    }, [selectedCrmModule])


    const submitValidation = useCallback(() => {
        const errorKeys = Object.keys(errors).filter((errorKey) => errors[errorKey])
        const errorMsgs = errorKeys.map((errorKey, i) => `${i + 1}) ${errors[errorKey]}.`).join('\n')
        return errorMsgs
    }, [errors])

    const handleRemoveField = useCallback((_id) => {
        if (!_id) return console.log(`Can't delete field`)
        const deleteFieldIndex = fields.findIndex((field) => field._id === _id)
        if (deleteFieldIndex < 0 || !fields[deleteFieldIndex].isDeletable) return alertCtx.showAlert(t('Error'), t('You cant delete thid field.'), 'md')
        setFields((fields) => {
            const newFields = JSON.parse(JSON.stringify(fields))
            // const deleteFieldIndex = newFields.findIndex((field) => field._id === _id)
            if (deleteFieldIndex > -1) {
                newFields.splice(deleteFieldIndex, 1)
                return newFields
            }
            return fields
        })
        const updatedModule = JSON.parse(JSON.stringify(selectedCrmModule))
        if (updatedModule?.sections) {
            for (const section of updatedModule.sections) {
                const fieldIndex = section.fields.findIndex((field) => {
                    return field._id === _id
                })
                if (fieldIndex > -1) {
                    section.fields.splice(fieldIndex, 1)
                    break;
                }
            }
        }
        dispatch(actions.updateCrmModule(updatedModule))
        modalToggel()
    }, [selectedCrmModule, fields])

    const handleSubmit = useCallback(() => {
        const updatedModule = JSON.parse(JSON.stringify(selectedCrmModule))
        let errors = submitValidation()
        if (!manageFieldState.fieldObj.label && !manageFieldState.fieldObj.type === 'reference') {
            errors = `- ${t('Show label')}: ${t('Required')}.\n${errors} 
            `
        }
        if (errors || (!manageFieldState.fieldObj.label && !manageFieldState.fieldObj.type === 'reference')) {
            return alertCtx.showAlert(t('Error'), errors, 'md')
        }

        let toSaveFieldObj = { ...manageFieldState.fieldObj }
        if (manageFieldState.fieldObj.type === 'select' && dropDownState.selectedDropDownObj?._id) {

            let defaultValue = dropDownState.selectedDropDownOption?.value !== 'Create' ? dropDownState.selectedDropDownOption.value : undefined
            toSaveFieldObj = { ...toSaveFieldObj, dropDownId: dropDownState.selectedDropDownObj._id, defaultValue }

        }
        if (manageFieldState.fieldObj.type === 'reference') {
            const refModelId = manageFieldState.fieldObj.refModelId?._id || manageFieldState.fieldObj.refModelId;
            let module = (relatedModules.find(relatedModule => relatedModule.moduleId?._id === refModelId))?.moduleId;

            // If module not found in relatedModules and we have a refModelId object, use it directly (for existing fields)
            if (!module && manageFieldState.fieldObj.refModelId?._id) {
                module = manageFieldState.fieldObj.refModelId;
            }

            if (!module) {
                return alertCtx.showAlert(t('Error'), t('Module not selected.'), 'md')
            }
            const moduleName = module.name

            // Only generate field name for new fields (INSERT mode)
            if (manageFieldState.mode === 'INSERT') {
                toSaveFieldObj.name = `crmName${moduleName}`
            }
            // For PATCH mode, keep existing field name (already in toSaveFieldObj)

            //selectedModuleFields
            // toSaveFieldObj.label = (selectedModuleFields.find((moduleField) => moduleField.name === manageFieldState.fieldObj.displayField))?.label
            if (manageFieldState.mode === 'PATCH') {
                // Keep existing label for PATCH mode (already in toSaveFieldObj from manageFieldState.fieldObj)
            }
            else {
                toSaveFieldObj.label = (selectedModuleFields.find((moduleField) => moduleField.name === 'crmName'))?.label
            }
            console.log(toSaveFieldObj.label)
        }
        if (updatedModule?.sections) {
            if (manageFieldState.mode === 'PATCH') {

                for (const section of updatedModule.sections) {
                    const fieldIndex = section.fields.findIndex((field) => {
                        return field._id === toSaveFieldObj._id
                    })
                    if (fieldIndex > -1) {
                        section.fields[fieldIndex] = toSaveFieldObj
                        break;
                    }
                }

            }
            else if (manageFieldState.mode === 'INSERT') {
                const systemSection = updatedModule.sections.find(section => {
                    return section.name === 'systemSection'
                })
                if (!systemSection) {
                    updatedModule.sections.push({
                        name: 'systemSection',
                        label: 'systemSection',
                        fields: [toSaveFieldObj]
                    })
                }
                else {
                    systemSection.fields.push(toSaveFieldObj)
                }
            }
        }
        // Wrap dispatch in setTimeout to avoid AG Grid rendering conflicts
        setTimeout(() => {
            dispatch(actions.updateCrmModule(updatedModule))
        }, 0)
        modalToggel()
    }, [selectedCrmModule, manageFieldState.fieldObj, dropDownState.selectedDropDownObj, dropDownState.selectedDropDownOption, fields])

    const columnDefs = [
        { field: 'name', headerName: t('name'), flex: 1 },
        { field: 'label', headerName: t('Label to be displayed'), flex: 1 },
        { field: 'type', headerName: t('Type of field'), flex: 1 },
    ]

    const handleNewFieldClick = useCallback((event) => {
        manageFieldDispatch({ type: 'SET_FIELD', fieldObj: newFieldObj, mode: 'INSERT' })
    }, [])

    const handleFieldClick = useCallback((event) => {
        if (event?.data) {
            manageFieldDispatch({ type: 'SET_FIELD', fieldObj: event.data, mode: 'PATCH' })
        }
    }, [])

    const getModuleFields = useCallback((module) => {
        let fields = []
        if (module?.sections) {
            for (const section of module.sections) {
                fields = [...fields, ...section.fields]
            }
        }
        fields.forEach(field => field.value = field.name)
        return fields
    }, [])

    const dataTypeOptions = [
        { label: t('TextField'), value: 'text' },
        { label: t('Number'), value: 'number' },
        { label: t('TextArea'), value: 'textarea' },
        { label: t('DropDown'), value: 'select' },
        { label: t('CheckBox'), value: 'boolean' },
        { label: t('Date'), value: 'date' },
        { label: t('DateTime'), value: 'datetime' },
        { label: t('Phone'), value: 'phone' },
        { label: t('Email'), value: 'email' },
        { label: t('RelatedModule'), value: 'reference' },
        { label: t('File'), value: 'file' }
    ]

    const modalToggel = useCallback(() => {
        if (manageFieldState.showModal === true) {
            dropDownDispatch({ type: 'CLEAR_ALL' })
            manageFieldDispatch({ type: 'CLEAR_ALL' })
            setErrors({});
        }
        else {
            manageFieldDispatch({ type: 'TOGGEL_MODAL' })
        }

    }, [manageFieldState.showModal])



    const validations = useCallback((name, value) => {
        if (typeof value !== 'string') return
        if (name === 'name') {
            if (validator.isEmpty(value)) {
                return `${t('Field name')}: ${t(`Required`)}`;
            }

            if (!validator.isAlpha(value, 'en-US')) {
                return `${t('Field name')}: ${t(`Only x letters are allowed`, { x: t('English') })}`;
            }

            if (!validator.isLength(value, { min: 9 })) {
                return `${t('Field name')}: ${t(`Must be more than x characters`, { x: 8 })}`;
            }

            if (!validator.isLength(value, { max: 32 })) {
                return `${t('Field name')}: ${t(`Must not exceed x characters`, { x: 32 })}`;
            }
        }
        if (name === 'label') {
            if (validator.isEmpty(value)) {
                return `${t('Show label')}: ${t(`Required`)}`;
            }

            if (!validator.isLength(value, { min: 3 })) {
                return `${t('Show label')}: ${t(`Must be more than x characters`, { x: 2 })}`;
            }

            if (!validator.isLength(value, { max: 32 })) {
                return `${t('Show label')}: ${t(`Must not exceed x characters`, { x: 32 })}`;
            }
        }
        if (name === 'tooltip') {
            if (!validator.isLength(value, { max: 64 })) {
                return `${t('tooltip')}: ${t(`Must not exceed x characters`, { x: 64 })}`;
            }
        }
        if (name === 'defaultValue') {
            if (!validator.isLength(value, { max: 64 })) {
                return `${t('Default value')}: ${t(`Must not exceed x characters`, { x: 64 })}`;
            }
            if (manageFieldState.fieldObj?.type === 'phone') {
                if (!validator.isMobilePhone(value, 'any', { strictMode: false }))
                    return `${t('Default value')}: ${t(`The number is incorrect`)}`;
            }
            if (manageFieldState.fieldObj?.type === 'email') {
                if (!validator.isEmail(value))
                    return `${t('Default value')}: ${t(`Invalid email`)}`;
            }
        }
        if (name === 'maxNumber') {
            if (!validator.isNumeric(String(value), { no_symbols: true })) {
                return `${t('Max number')}: ${t('Must be a valid number')}`;
            }
        }
        return;
    }, [manageFieldState.fieldObj?.type])

    const handleChange = useCallback((e) => {
        const { name, value, type, checked } = e.target;
        manageFieldDispatch({ type: 'PATCH_FIELD', payload: { name, value, type, checked } })

        if (name === 'refModelId') {
            const module = (relatedModules.find(relatedModule => relatedModule.moduleId?._id === value))?.moduleId
            if (module) {
                const moduleFields = getModuleFields(module)
                setSelectedModuleFields(moduleFields)
            } else {
                setSelectedModuleFields([])
            }
        }

        const error = validations(name, value);
        setErrors((prev) => ({ ...prev, [`${name}`]: error }));
    }, [relatedModules])

    // Check if dropdown editing should be disabled (when field is NOT deletable/system field and type is select)
    const isDropdownEditingDisabled = useMemo(() => {
        return manageFieldState.fieldObj?.isDeletable === false && manageFieldState.fieldObj?.type === 'select';
    }, [manageFieldState.fieldObj?.isDeletable, manageFieldState.fieldObj?.type])

    return (
        <section >
            <CrmGrid
                rowData={fields}
                columnDefs={columnDefs}
                multiSelectionEnable={false}
                supportManageColumns={false}
                supportFiltering={false}
                supportMore={false}
                onRowClicked={handleFieldClick}
                onNewClicked={handleNewFieldClick}
                pagination={false}
            />
            {
                manageFieldState.showModal &&
                <SubModal
                    modalTitle={manageFieldState.mode === 'PATCH' ? t('Edit field') : t('Create new field')}
                    onHide={modalToggel}
                >
                    <Box
                        component="form"
                        onSubmit={(e) => e.preventDefault()}
                        noValidate
                        sx={{
                            p: 0,
                            display: 'flex',
                            flexDirection: 'column',
                            height: '100%',
                        }}
                    >
                        {/* Scrollable Fields Area */}
                        <Box
                            sx={{
                                flex: 1,
                                overflowY: 'auto',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                                pr: 1 // Optional: to prevent scroll bar from overlapping content
                            }}
                        >
                            <CrmSelectField name="type" sx={{ mt: 1 }} value={manageFieldState.fieldObj.type} disabled={manageFieldState.mode === 'PATCH'} onChange={handleChange} label={t('Data Type')} options={dataTypeOptions} />

                            {manageFieldState.fieldObj.type === 'select' && (
                                <>
                                    <CrmDivider>{t('DropDown managment')}</CrmDivider>

                                    {/* DropDown Controls */}
                                    <Box display="flex" gap={1} alignItems="center" width="100%">
                                        <CrmSelectField name="type" value={dropDownState.selectedDropDownObj.value} onChange={(e) => dropDownDispatch({ type: 'SET_DROPDOWN_OBJ', payload: { value: e.target.value } })} label={t('DropDown')} options={dropDownState.dropDownsArr} disabled={isDropdownEditingDisabled} />

                                        <CrmTextField label={t('DropDown name')} name="defaultValue" value={dropDownState.selectedDropDownObj.value === 'Create' ? '' : dropDownState.selectedDropDownObj.label} onChange={(e) => dropDownDispatch({ type: 'CHANGE_DROPDOWN_NAME', payload: { value: e.target.value } })} autoComplete='off' disabled={isDropdownEditingDisabled} />
                                        {!isDropdownEditingDisabled &&
                                            <>
                                                <CrmButton variant="contained" color="crmGray" onClick={onSaveDropDownClickedHandler} disabled={isDropdownEditingDisabled}> {t('Save')}</CrmButton>
                                                <CrmButton st={{ visibility: dropDownState.selectedDropDownObj?._id && !isDropdownEditingDisabled ? 'visible' : 'hidden' }} variant="outlined" color="crmOutLinedGray" onClick={onDeleteDropDownClickHandler}> {t('Remove')}</CrmButton>
                                            </>
                                        }
                                        <Box sx={{ visibility: 'hidden' }}>
                                            <CrmCheckBoxField
                                                label={t('Add Child Dropdown')}
                                                name="placeholderCheckbox"
                                                value={false}
                                                onChange={() => { }}
                                            />
                                        </Box>
                                    </Box>
                                    {dropDownState.selectedDropDownObj?._id &&
                                        <>
                                            <Box display="flex" gap={1} alignItems="center" width="100%">
                                                <CrmSelectField name="type" value={dropDownState.selectedDropDownOption.value} onChange={(e) => dropDownDispatch({ type: 'SET_DROPDOWN_SELECTED_OPTION', payload: { value: e.target.value } })} label={t('Default value')} options={dropDownState.selectedDropDownObj.dropDownItems} disabled={isDropdownEditingDisabled} />
                                                <CrmTextField label={t('DropDown options name')} name="defaultValue" value={dropDownState.selectedDropDownOption.value === 'Create' ? '' : dropDownState.selectedDropDownOption.label} onChange={(e) => dropDownDispatch({ type: 'CHANGE_DROPDOWN_SELECTED_OPTION_NAME', payload: { value: e.target.value } })} autoComplete='off' disabled={isDropdownEditingDisabled} />
                                                {!isDropdownEditingDisabled &&
                                                    <>
                                                        <CrmButton variant="contained" color="crmGray" onClick={onSaveDropDownOptionClickedHandler} disabled={isDropdownEditingDisabled}> {t('Save')}</CrmButton>
                                                        <CrmButton variant="outlined" color="crmOutLinedGray" onClick={onDeleteDropDownOptionClickHandler} st={{ visibility: dropDownState.selectedDropDownOption?._id && !isDropdownEditingDisabled ? 'visible' : 'hidden' }}> {t('Remove')}</CrmButton>
                                                    </>
                                                }
                                                <CrmCheckBoxField
                                                    label={t('Add Child Dropdown')}
                                                    name="hasChildren"
                                                    value={Array.isArray(dropDownState.selectedDropDownOption?.children)}
                                                    onChange={async (e) => {
                                                        const hasChildren = e.target.checked;

                                                        // Create updated option for API call
                                                        const updatedOption = JSON.parse(JSON.stringify(dropDownState.selectedDropDownOption));
                                                        if (hasChildren) {
                                                            if (!updatedOption.children) {
                                                                updatedOption.children = [];
                                                            }
                                                        } else {
                                                            delete updatedOption.children;
                                                        }

                                                        // Update local state first
                                                        dropDownDispatch({
                                                            type: 'TOGGLE_CHILD_DROPDOWN',
                                                            payload: { hasChildren }
                                                        });

                                                        // Persist to backend
                                                        try {
                                                            await updateDropDownItem(dropDownState.selectedDropDownObj, updatedOption);
                                                        } catch (error) {
                                                            console.error('Failed to update dropdown:', error);
                                                            alertCtx.showAlert(t('Error'), t('Failed to save changes'), 'sm');
                                                        }
                                                    }}
                                                    style={{ visibility: dropDownState.selectedDropDownOption?.value !== 'Create' && !isDropdownEditingDisabled ? 'visible' : 'hidden' }}
                                                    disabled={isDropdownEditingDisabled}
                                                />
                                            </Box>

                                            {/* Custom Child Level Name Management - Main Level */}
                                            {!isDropdownEditingDisabled && Array.isArray(dropDownState.selectedDropDownOption?.children) && dropDownState.selectedDropDownOption?.value !== 'Create' && (
                                                <Box mt={2} p={2} border="1px solid #e0e0e0" borderRadius={1} bgcolor="#f9f9f9">
                                                    <Box display="flex" gap={1} alignItems="center" width="100%">
                                                        <CrmTextField
                                                            label={`${t('Child Level Name')} - ${t('Level')} 1`}
                                                            name="mainChildLevelName"
                                                            value={dropDownState.selectedDropDownOption.childLevelName || ''}
                                                            onChange={(e) => {
                                                                dropDownDispatch({
                                                                    type: 'SET_CHILD_LEVEL_NAME',
                                                                    payload: { value: e.target.value }
                                                                });
                                                            }}
                                                            placeholder={t('e.g., Category, Type, Size')}
                                                            autoComplete='off'
                                                            sx={{ flexGrow: 1 }}
                                                            disabled={isDropdownEditingDisabled}
                                                        />
                                                        <CrmButton
                                                            variant="contained"
                                                            color="crmGray"
                                                            onClick={async () => {
                                                                try {
                                                                    // Show loading spinner in alert modal
                                                                    alertCtx.showAlert('', <div style={{ textAlign: 'center', padding: '20px' }}><div className="spinner-border" role="status"><span className="sr-only">Loading...</span></div></div>, 'sm')

                                                                    const updatedOption = JSON.parse(JSON.stringify(dropDownState.selectedDropDownOption));
                                                                    await updateDropDownItem(dropDownState.selectedDropDownObj, updatedOption);
                                                                    alertCtx.showAlert(t('success'), t('Child level name updated successfully'), 'sm');
                                                                } catch (error) {
                                                                    console.error('Error updating child level name:', error);
                                                                    alertCtx.showAlert(t('error'), t('Failed to update child level name'), 'sm');
                                                                }
                                                            }}
                                                            disabled={isDropdownEditingDisabled}
                                                        >
                                                            {t('Save')}
                                                        </CrmButton>
                                                    </Box>
                                                </Box>
                                            )}

                                            {/* Recursive Child Options Management */}
                                            {!isDropdownEditingDisabled && (
                                                <RecursiveChildManager
                                                    key={`root-${dropDownState.selectedDropDownOption?.value}-${dropDownState.selectedDropDownOption?.children?.length || 0}`}
                                                    parentOption={dropDownState.selectedDropDownOption}
                                                    dropDownState={dropDownState}
                                                    dropDownDispatch={dropDownDispatch}
                                                    updateDropDownItem={updateDropDownItem}
                                                    alertCtx={alertCtx}
                                                    t={t}
                                                    level={0}
                                                />
                                            )}


                                        </>
                                    }

                                    <Box display="flex" justifyContent="flex-start" gap={2}></Box>
                                    <CrmDivider />
                                </>
                            )}
                            {
                                manageFieldState.fieldObj.type === 'reference' &&
                                <CrmSelectField name="refModelId" sx={{ mt: 1 }} value={manageFieldState.fieldObj.refModelId?._id || manageFieldState.fieldObj.refModelId} disabled={manageFieldState.mode === 'PATCH'} onChange={handleChange} label={t('Module')} options={relatedModules} />
                            }
                            {/* {
                                (manageFieldState.fieldObj.refModelId?._id || manageFieldState.fieldObj.refModelId) &&
                                <CrmSelectField name="displayField" sx={{ mt: 1 }} value={manageFieldState.fieldObj.displayField} disabled={manageFieldState.mode === 'PATCH'} onChange={handleChange} label={t('Display Module Field')} options={selectedModuleFields} />
                            } */}

                            {
                                manageFieldState.fieldObj.type !== 'reference' &&
                                <CrmTextField label={t('Field name')} name="name" value={manageFieldState.fieldObj.name} onChange={handleChange} disabled={manageFieldState.mode === 'PATCH'} autoComplete='off' errorMsg={errors.name} />
                            }
                            {
                                manageFieldState.fieldObj.type !== 'reference' &&
                                <CrmTextField label={t('Show label')} name="label" value={manageFieldState.fieldObj.label} onChange={handleChange} autoComplete='off' errorMsg={errors.label} />
                            }
                            <CrmTextField label={t('tooltip')} name="tooltip" value={manageFieldState.fieldObj.tooltip} onChange={handleChange} autoComplete='off' errorMsg={errors.tooltip} />
                            {(manageFieldState.fieldObj.type === 'text' || manageFieldState.fieldObj.type === 'textarea' || manageFieldState.fieldObj.type === 'phone' || manageFieldState.fieldObj.type === 'email') &&
                                <CrmTextField
                                    label={t('Default value')}
                                    name="defaultValue"
                                    value={manageFieldState.fieldObj.defaultValue}
                                    onChange={handleChange}
                                    disabled={manageFieldState.fieldObj.type === 'select'}
                                    errorMsg={errors.defaultValue}
                                />}
                            {(manageFieldState.fieldObj.type === 'date' || manageFieldState.fieldObj.type === 'datetime') &&
                                <CrmDateTime label={t('Default value')} name="defaultValue" value={manageFieldState.fieldObj.defaultValue} type={manageFieldState.fieldObj.type} onChange={handleChange} />
                            }
                            {manageFieldState.fieldObj.type === 'boolean' &&
                                <CrmCheckBoxField label={t('Default value')} name="defaultValue" value={manageFieldState.fieldObj.defaultValue} onChange={handleChange} />
                            }

                            {manageFieldState.fieldObj.type === 'number' && (
                                <CrmTextField label={t('Max number')} name="maxNumber" value={manageFieldState.fieldObj.maxNumber} onChange={handleChange} type="number" autoComplete='off' errorMsg={errors.maxNumber} />
                            )}
                            {
                                manageFieldState.fieldObj.type !== 'file' && <>
                                    <CrmCheckBoxField label={t('Required')} name="required" value={manageFieldState.fieldObj.required} onChange={handleChange} />
                                    <CrmCheckBoxField label={t('Importable')} name="importable" value={manageFieldState.fieldObj.importable} onChange={handleChange} />
                                    <CrmCheckBoxField label={t('Show in Columns')} name="showColumns" value={manageFieldState.fieldObj.showColumns} onChange={handleChange} />
                                    <CrmCheckBoxField label={t('Display in Filters')} name="showFilters" value={manageFieldState.fieldObj.showFilters} onChange={handleChange} />
                                </>
                            }
                        </Box>

                        <CrmDivider sx={{ my: 2 }} />

                        {/* Footer Buttons */}
                        <Box display="flex" justifyContent="flex-end" gap={2}>
                            {/* <CrmButton variant="contained" color="primary" onClick={handleSubmit}>
                                {t('Save')}
                            </CrmButton> */}
                            <CrmButton color="crmContainedGray94" onClick={handleSubmit}>
                                {t('Save')}
                            </CrmButton>
                            {manageFieldState.mode === 'PATCH' && manageFieldState.fieldObj?.isDeletable &&
                                <CrmButton color="error" variant="contained" onClick={() => handleRemoveField(manageFieldState.fieldObj?._id)}>
                                    {t('Delete')}
                                </CrmButton>
                            }
                            {/* <CrmButton variant="outlined" color="primary" onClick={modalToggel}>
                                {t('Cancel')}
                            </CrmButton> */}
                            <CrmButton color="crmOutlinedGray94" onClick={modalToggel}>
                                {t('Cancel')}
                            </CrmButton>
                        </Box>
                    </Box>
                </SubModal>
            }
        </section>
    );
};

export default FieldsManagment;
